import { GenericService } from '../../../../core/services/GenericService';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../../core/services';
import { Observable } from 'rxjs';
import { ITableResults } from '../../../../core/interfaces';
import { INonPackableArticle } from '../interfaces/INonPackableArticle';
import { IBulkContainerChangeLog } from '../interfaces/IBulkContainerChangeLog';
import { IBulkContainer } from '../interfaces/IBulkContainer';
import { HttpUtils } from '../../../../core/utils/HttpUtils';

@Injectable({
  providedIn: 'root'
})
export class NonPackableService extends GenericService<IBulkContainer> {
  protected readonly baseUrl = '/nonpackable';

  constructor(public apiService: ApiService) {
    super(apiService);
  }

  getQueryableArticlesAll( pageIndex: number,
                   pageSize: number,
                   sortField: string | null,
                   sortOrder: string | null,
                   filters: Array<{ key: string; value: string[] }>,
                   search: Array<{ key: string; value: string[] }>,
                           additionalFilters: Array<{ key: string; value: string[] }>,
  ): Observable<ITableResults<INonPackableArticle>> {
    const params = HttpUtils.prepareQueryableParams(pageIndex, pageSize, sortField, sortOrder, filters, search, additionalFilters);
    return this.apiService.get(`${this.baseUrl}/articles`, params);
  }

  getNonPackableArticleById(articleId: number): Observable<INonPackableArticle> {
     return this.apiService.get(`${this.baseUrl}/articles/${articleId}`);
  }

  getQueryableNonPackableChangeLogByArticleId(articleId: number,
                                       pageIndex: number,
                                       pageSize: number,
                                       sortField: string | null,
                                       sortOrder: string | null,
                                       filters: Array<{ key: string; value: string[] }>): Observable<ITableResults<IBulkContainerChangeLog>> {
    const params = HttpUtils.prepareQueryableParams(pageIndex, pageSize, sortField, sortOrder, filters, null, []);
    return this.apiService.get(`${this.baseUrl}/articles/${articleId}/change-logs`, params);
  }

  createChangeLog(bulkContainerId, object:{quantity:number, comment:string}):Observable<any> {
    return this.apiService.post(`${this.baseUrl}/${bulkContainerId}/change-log`, object);
  }

  cancel(bulkContainerId): Observable<any> {
    return this.apiService.post(`${this.baseUrl}/${bulkContainerId}/cancel`);
  }
}
